<template>
  <div class="mt-6">
    <b-field :label="$t('options')" />
    <div>
      <div class="table">
        <tr>
          <td><b-field :label="$t('personalization')" /></td>
          <td>
            <b-switch v-model="options.personalization">
              {{ options.personalization ? $t("Yes") : $t("No") }}
            </b-switch>
          </td>
        </tr>
        <b-message type="is-primary">
          {{ $t("personalizationExplained") }}
        </b-message>
        <div v-if="options.personalization">
          <Personalization />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Personalization from "@/components/survey/Personalization";

export default {
  name: "SurveyCreatorOptions",
  components: {
    Personalization,
  },
  data() {
    return {};
  },
  computed: {
    options: {
      get() {
        return this.$store.state.survey.options;
      },
      set(value) {
        this.$store.commit("SET_SURVEY_FIELD", ["options", value]);
      },
    },
  },
};
</script>

<style></style>
